import InsufficientCoverageWarningContent from 'components/common/insufficient-coverage-warning-content';
import { SystemOptionType } from 'data/types';
import { createElement } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { collectInsufficientCoverageWarnings } from 'utils/insufficient-coverage-warning';
import { sweetalertButtonClasses } from 'utils/sweetalert-button-classes';

const sweetalert = withReactContent(Swal);

export function insufficientCoverageWarningModal(
  systems: SystemOptionType[]
): Promise<void> {
  const entries = collectInsufficientCoverageWarnings(systems);
  if (entries.length === 0) return Promise.resolve();
  return sweetalert
    .fire({
      title: 'Coverage warning',
      html: createElement(InsufficientCoverageWarningContent, { entries }),
      icon: 'warning',
      showCancelButton: false,
      confirmButtonText: 'OK',
      buttonsStyling: false,
      customClass: {
        confirmButton: sweetalertButtonClasses().confirmButton
      }
    })
    .then(() => undefined);
}
